import { PaperClipIcon } from '@heroicons/react/24/outline';
import React from 'react';

const AddDocumentsCard = () => {
  return (
    <div className="min-w-screen">
      <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
        <div className="flex justify-between">
          <h5 className="text-2xl tracking-tight text-gray-900 text-[25px]">
            Additional Documents
          </h5>
          <PaperClipIcon
            className="block h-6 w-6 hover:cursor-pointer"
            aria-hidden="true"
          />
        </div>
        <div className="flex">
          <div className="flex-col w-full">
            {/* {data &&
                            data.map((item) => (
                                <InformationCardRow
                                    editing={editing}
                                    type={type}
                                    heading={item.heading}
                                />
                            ))} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDocumentsCard;
